import gql from 'graphql-tag';

export const INDICADOR_FUP48_E_TD = gql`
  query IndicadorFup48eTD(
    $dataInicio: DateTime
    $dataFim: DateTime
    $dealerPk: ID
    $userId: ID
    $marcaId: ID
    $unidadeNegocioId: ID
  ) {
    indicadorFup48eTD(
      filter: {
        dataInicio: $dataInicio
        dataFim: $dataFim
        dealerPk: $dealerPk
        usuarioId: $userId
        marcaId: $marcaId
        unidadeNegocioId: $unidadeNegocioId
      }
    ) {
      totalTD
      pendentesTD
      idsTD
      totalFup48
      pendentesFup48
      idsFup48
      porcentagemTD
      porcentagemFup
    }
  }
`;
